var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-editor',{attrs:{"data":_vm.data,"records":_vm.records,"sources":_vm.sources},on:{"save":function($event){return _vm.update(false)},"save-and-exit":function($event){return _vm.update(true)}}})}
var staticRenderFns = []

export { render, staticRenderFns }